//--dependancies--
import React from "react"
import styled from "styled-components"

//--components--
import Layout from "../components/layout"

const IndexPage = () => {
  return <Layout>Hello there</Layout>
}

export default IndexPage
